import { AxiosError, HttpStatusCode } from "axios";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "notistack";
import { useLocation } from "@tanstack/react-router";
import { captureException } from "@sentry/react";
import { HydraErrorResponse } from "@/types";
import { Paths } from "../features/auth/types";

const allowedRoutes = [Paths.Login.toString(), Paths.RecoveryEmail.toString()];

const useOnQueryError = <TErrorData extends HydraErrorResponse>(alternativeMessageKey: string) => {
  const { t } = useTranslation("coi-platform-translations");
  const { enqueueSnackbar } = useSnackbar();
  const pathname = useLocation({
    select: (location) => location.pathname,
  });

  const handleError = (error: AxiosError<TErrorData>) => {
    const { response } = error;
    if (!allowedRoutes.includes(pathname) && response?.status === HttpStatusCode.Unauthorized) return;

    captureException(error);

    const messages = response?.data?.violations || [];

    if (messages.length) {
      messages.forEach((message) => {
        enqueueSnackbar(t(message?.payload?.messageKey), {
          variant: "error",
        });
      });
    } else {
      const alternativeMessage = t(alternativeMessageKey);

      enqueueSnackbar(alternativeMessage, {
        variant: "error",
      });
    }
  };

  return handleError;
};

export default useOnQueryError;
